const accordionOuter = document.querySelector('.section-accordion__outer');
let openAccordion = null;
accordionOuter.addEventListener('mouseup', (event) => {
  if (event?.target?.closest('.section-accordion__header')) {
    toggleAccordion(event);
  }
});


accordionOuter.addEventListener('keydown', (event) => {
  if (event?.target?.closest('.section-accordion__header') && event.key === 'Enter') {
    toggleAccordion(event);
  }
});

function toggleAccordion(event) {
  const accordionItem = event.target.closest('.section-accordion__item');
  const header = accordionItem.querySelector('.section-accordion__header');
  const contentWrapper = accordionItem.querySelector('.section-accordion__wrapper');
  const isExpanded = header.getAttribute('aria-expanded') === 'true';

  if (openAccordion && openAccordion !== accordionItem) {
    const openHeader = openAccordion.querySelector('.section-accordion__header');
    const openWrapper = openAccordion.querySelector('.section-accordion__wrapper');
    openHeader.setAttribute('aria-expanded', 'false');
    openWrapper.setAttribute('aria-hidden', 'true');
    openWrapper.classList.remove('section-accordion__wrapper--open');
    openHeader.classList.remove('section-accordion__header--open');
  }

  if (isExpanded) {
    openAccordion = null;
  } else {
    openAccordion = accordionItem;
  }

  header.setAttribute('aria-expanded', !isExpanded);
  contentWrapper.setAttribute('aria-hidden', isExpanded);
  contentWrapper.classList.toggle('section-accordion__wrapper--open');
  header.classList.toggle('section-accordion__header--open', contentWrapper.classList.contains('section-accordion__wrapper--open'));
}
